module.exports = __webpack_public_path__ + "static/media/plan-D3b-mobile-tc.4b95e81f.png";